import { Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

function AdminDashboard({data, title, regiones}) {
  console.log(data);
  return <Container className="dashboard p-4">
    <h1>{title}</h1>
  <Row>
    <Col md={4}>
      <Card>
        <Card.Header>{data[0].title}</Card.Header>
        <Card.Body>{data[0].content}</Card.Body>
        {/* <Card.Footer>{data[0].footer}</Card.Footer> */}
      </Card>
    </Col>
    <Col md={4}>
        <Card>
          <Card.Header>{data[1].title}</Card.Header>
          <Card.Body>{data[1].content}</Card.Body>
          {/* <Card.Footer>{data[0].footer}</Card.Footer> */}
        </Card>
    </Col>
    <Col md={4}>
      <Card className="mb-4">
        <Card.Header>{data[2].title}</Card.Header>
        <Card.Body>{data[2].content}</Card.Body>
      </Card>
      <Card className="mb-4">
        <Card.Header>Regiones</Card.Header>
        <Card.Body>{regiones.map(r => <p><Link to={`/app/org/regiones/${r.region_id}`}>{r.label}</Link></p>)}</Card.Body>
      </Card>
      {data[3] && <Card>
        <Card.Header>{data[3].title}</Card.Header>
        <Card.Body>{data[3].content}</Card.Body>
      </Card> }
    </Col>
  </Row>
</Container>
}

export default AdminDashboard;
